import { Card, FAQ } from './types';

export const cards: Card[] = [
    {
        id: 1,
        icon: 'card-icon-shipping-leads.svg',
        title: 'Instantly Access Global Opportunities',
        description: 'With DFA, shipping leads aren\’t just local—they\'re global. By connecting with businesses across continents, you can expand your reach into new markets effortlessly. This global access gives you the chance to diversify your client base and grow your revenue streams without geographical limits.',
        alt: 'Instantly Access Global Opportunities',
    },
    {
        id: 2,
        icon: 'card-icon-networking.svg',
        title: 'Receive Targeted Lead Matching for Precision Growth',
        description: 'No more chasing cold leads. DFA’s platform uses intelligent algorithms to match your services with the right businesses based on their specific shipping needs. This precision targeting means higher conversion rates and more efficient sales efforts, saving time and boosting profits.',
        alt: 'Receive Targeted Lead Matching',    
    },
    {
        id: 3,
        icon: 'card-icon-support.svg',
        title: 'Gain a Competitive Advantage with Real-Time Bidding',
        description: 'By being the first to respond to new shipping requests, you position your company ahead of competitors. DFA’s real-time bidding system ensures that you can quickly showcase your rates and services, giving you a significant edge in securing deals faster.',
        alt: 'Competitive Advantage',
    },
    {
        id: 4,
        icon: 'card-icon-digital-tools.svg',
        title: 'Strengthen Client Relationships Through Consistency',
        description: 'Consistent lead flow allows you to build long-term partnerships rather than one-off deals. DFA’s leads open doors to recurring contracts, helping you develop a reputation for reliability and strengthening your brand presence in the industry.',
        alt: 'Strengthen Client Relationships',
    },
    {
        id: 5,
        icon: 'card-icon-brand-reliability.svg',
        title: 'Reduce Sales Cycles and Higher Efficiency',
        description: 'DFA’s shipping leads help you streamline your sales cycle by eliminating the need for extensive prospecting. With leads delivered directly to your inbox, your team can focus on converting opportunities into bookings, reducing time spent on unproductive tasks.',
        alt: 'Higher Efficiency',
    },
];

export const faq: FAQ[] = [
  {
    id: "1",
    question: "How do I receive shipping leads from DFA?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          You’ll receive leads directly through the DFA platform. Once you’ve signed up, relevant shipping requests are sent to your dashboard, where you can review and submit your bids.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "What types of shipping leads can I expect?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          DFA provides a variety of leads, including FCL (Full Container Load), LCL (Less than Container Load), air freight, and other specialised cargo needs from all over the world, catering to diverse shipping requirements.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "Are the leads tailored to my business?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
           Yes, DFA’s system uses smart matching to connect you with leads that align with your services, locations, and expertise, ensuring more relevant and high-conversion opportunities.
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "How quickly can I respond to a lead?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          You can respond as soon as a lead is posted. Real-time notifications ensure you’re one of the first to bid, giving you a competitive advantage.
        </p>
      `
    ),
  },
  {
    id: "5",
    question: "Is there a limit to the number of leads I can access?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          No, there’s no limit. As long as you’re an active member, you can access all available leads on the platform and bid on as many as you want.
        </p>
      `
    ),
  },
  {
    id: "6",
    question: "What happens if I win a lead?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Once you win a lead, you’ll be connected directly with the client to finalize details and move forward with the shipping process, helping you establish long-term relationships.
        </p>
      `
    ),
  },
  {
    id: "7",
    question: "Are there any costs involved in accessing these leads?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Shipping leads are included in your DFA membership. There are no additional fees for receiving or bidding on leads, ensuring full transparency and value for your membership.
        </p>
      `
    ),
  },
  {
    id: "8",
    question: "How do I increase my chances of winning leads?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Offering competitive rates, fast response times, and clear communication significantly increases your chances. Highlighting your unique services also helps you stand out from competitors.
        </p>
      `
    ),
  },
  {
    id: "9",
    question: "Can I track the progress of my bids?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Yes, the platform allows you to monitor the status of your bids, from submission to client decision, providing full visibility into the process.
        </p>
      `
    ),
  },
  {
    id: "10",
    question: "What support does DFA offer if I have issues with a lead?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          DFA’s support team is available to assist with any lead-related queries or issues, ensuring smooth communication and resolution throughout the bidding process.
        </p>
      `
    ),
  },
];